import { defineModule } from './module-utils';

type SnackbarData = Partial<{
  show: boolean;
  text: string;
  icon: string;
  color: string;
  timeout: number;
  bottom: boolean;
  top: boolean;
  left: boolean;
  right: boolean;
  outline: boolean;
  rounded: boolean | string;
  multiLine: boolean;
}>;

type AlertData = Partial<{
  show: boolean;
  text: string;
  title: string;
  type: 'success' | 'info' | 'warning' | 'error';
  border: 'left' | 'right' | 'top' | 'bottom';
  timeout: number;
  dismissible: boolean;
  prominent: boolean;
}>;

const notifications = defineModule({
  state: {
    snackbar: {
      show: false,
      text: '',
      icon: '',
      color: 'primary',
      timeout: 4000,
      bottom: true,
      top: false,
      left: false,
      right: true,
      outline: false,
      rounded: 'lg',
      multiLine: false,
    } as SnackbarData,
    alert: {
      show: false,
      text: '',
      title: '',
      type: 'info',
      dismissible: true,
      prominent: true,
      border: 'left',
      timeout: 0,
    } as AlertData,
  },

  getters: {
    snackbar(state) {
      return state.snackbar;
    },
    alert(state) {
      return state.alert;
    },
  },

  mutations: {
    setSnackbar(state, snackbarData: SnackbarData) {
      state.snackbar = snackbarData;
    },
    setAlert(state, alertData: AlertData) {
      state.alert = alertData;
    },
  },

  actions: {
    updateSnackbar({ commit }, data: SnackbarData) {
      console.log('setSnackbar', data);
      commit('setSnackbar', data);
    },
    updateAlert({ commit }, data: AlertData) {
      console.log('setAlert', data);
      commit('setAlert', data);
    },
  },
});

export default notifications;
